module.exports = __webpack_public_path__ + "static/media/60.ab3a2246.svg";